import { object, string } from 'yup'

export type FormValues = {
  phoneNumber: string
}

const errorMessage = 'Please enter a valid phone number'

export const validationSchema = object().shape({
  phoneNumber: string()
    .required(errorMessage)
    .matches(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/, errorMessage),
})

export const mapPropsToValues = props => {
  const { phoneNumber } = props

  return {
    phoneNumber: phoneNumber || '',
  }
}
